<template>
  <b-modal
    :id="modalId"
    modal-class="p-4 big-modal"
    dialog-class="modal-md"
    content-class="text-center pb-2"
    no-close-on-esc
    no-close-on-backdrop
    hide-header
    hide-footer
    lazy
  >
    <div class="gigawhat-modal">
      <div class="modal-heading mt-3 ml-4 ">
        <h2 class="modal-title">
          Consulter les versions précédentes -
          <span v-if="Array.isArray(selectedDocument.types)">
            {{ selectedDocument.types[0].name }}
          </span>
          <span v-else>{{ selectedDocument.types.name }}</span>
        </h2>
      </div>
      <div class="giga-files_upload ml-4">
        <div class="giga-files_upload_section d-flex">
          <div class="w-85 d-flex flex-column">
            <div class="giga-files_upload_header" v-if="getVersionsDocument">
              <div class="giga-files_header_col_name">
                <h3 class="giga-files_upload_title">
                  Nom du document
                </h3>
              </div>
              <div class="giga-files_header_col_date">
                <h3 class="giga-files_upload_title">
                  Date de chargement
                </h3>
              </div>
              <div class="giga-files_header_col_type">
                <h3 class="giga-files_upload_title">
                  Version
                </h3>
              </div>
            </div>
            <div class="giga-upload_files_list">
              <div class="giga-upload_file_item">
                <div class="giga-upload_file_name">
                  <i class="extention-icon">
                    <img
                      v-if="getFileExtention(selectedDocument.name) === 'xlsx'"
                      alt="xlsx.svg"
                      src="~@/assets/images/extensions/xls.svg"
                    />
                    <img
                      v-else-if="
                        getFileExtention(selectedDocument.name) === 'txt'
                      "
                      alt="txt.svg"
                      src="~@/assets/images/extensions/txt.svg"
                    />
                    <img
                      v-else-if="
                        getFileExtention(selectedDocument.name) === 'pdf'
                      "
                      alt="pdf.svg"
                      src="~@/assets/images/extensions/pdf.svg"
                    />
                    <img
                      v-else-if="
                        getFileExtention(selectedDocument.name) === 'docx'
                      "
                      alt="docx.svg"
                      src="~@/assets/images/extensions/doc.svg"
                    />
                    <img
                      v-else-if="
                        getFileExtention(selectedDocument.name) === 'doc'
                      "
                      alt="doc.svg"
                      src="~@/assets/images/extensions/doc.svg"
                    />
                    <img
                      v-else-if="
                        getFileExtention(selectedDocument.originalFileName) ===
                          'zip'
                      "
                      alt="zip.svg"
                      src="~@/assets/images/extensions/zip.svg"
                    />
                    <img
                      v-else
                      alt="text.svg"
                      src="~@/assets/images/extensions/text.svg"
                    /> </i
                  >{{ selectedDocument.name }}
                </div>
                <div class="giga-upload_file_date">
                  <span v-if="selectedDocument.creationDate"
                    >{{
                      moment(selectedDocument.creationDate, "x").format(
                        "DD/MM/YYYY"
                      )
                    }}
                  </span>
                  <span v-else>{{
                    new Date().toLocaleDateString("fr-FR")
                  }}</span>
                </div>
                <div class="giga-upload_file_type">
                  V{{ currentDocument().version }}
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <div class="giga-button">
              <button
                class="with-icon giga-blue_button"
                @click="downloadDoc(currentDocument().documentId)"
              >
                <i class="giga-icon">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="7 10 12 15 17 10" />
                    <line x1="12" y1="15" x2="12" y2="3" />
                  </svg>
                </i>
                <span> {{ $t("download") }}</span>
              </button>
            </div>
          </div>
        </div>
        <strong class="mt-4">Versions Précédentes</strong>
        <table class="giga-table" style="width: 97%">
          <thead>
            <tr style="background-color: #132D48; height: 25px">
              <th class="text-white">Nom du document</th>
              <th class="text-white">Date de chargement</th>
              <th class="text-white">Version</th>
              <th class="text-white">Actions</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="versionDocument in getVersionsDocument">
              <tr
                v-if="currentDocument() !== versionDocument"
                :key="versionDocument.documentId"
              >
                <td>
                  <i class="extention-icon">
                    <img
                      v-if="getFileExtention(versionDocument.name) === 'xlsx'"
                      alt="xlsx.svg"
                      src="~@/assets/images/extensions/xls.svg"
                    />
                    <img
                      v-else-if="
                        getFileExtention(versionDocument.name) === 'txt'
                      "
                      alt="txt.svg"
                      src="~@/assets/images/extensions/txt.svg"
                    />
                    <img
                      v-else-if="
                        getFileExtention(versionDocument.name) === 'pdf'
                      "
                      alt="pdf.svg"
                      src="~@/assets/images/extensions/pdf.svg"
                    />
                    <img
                      v-else-if="
                        getFileExtention(versionDocument.name) === 'docx'
                      "
                      alt="docx.svg"
                      src="~@/assets/images/extensions/doc.svg"
                    />
                    <img
                      v-else-if="
                        getFileExtention(versionDocument.name) === 'doc'
                      "
                      alt="doc.svg"
                      src="~@/assets/images/extensions/doc.svg"
                    />
                    <img
                      v-else-if="
                        getFileExtention(versionDocument.name) === 'zip'
                      "
                      alt="zip.svg"
                      src="~@/assets/images/extensions/zip.svg"
                    />
                    <img
                      v-else
                      alt="text.svg"
                      src="~@/assets/images/extensions/text.svg"
                    /> </i
                  >{{ versionDocument.name }}
                </td>
                <td>
                  <span v-if="versionDocument.creationDate"
                    >{{
                      moment(versionDocument.creationDate, "x").format(
                        "DD/MM/YYYY"
                      )
                    }}
                  </span>
                  <span v-else>{{
                    new Date().toLocaleDateString("fr-FR")
                  }}</span>
                </td>
                <td>V{{ versionDocument.version }}</td>
                <td>
                  <button
                    class="bg-transparent border-0"
                    @click="downloadDoc(versionDocument.documentId)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                      <polyline points="7 10 12 15 17 10" />
                      <line x1="12" y1="15" x2="12" y2="3" />
                    </svg>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="gigwhat-model_footer mt-5 ml-3">
        <div class="half-footer left-content">
          <div class="giga-button">
            <button
              id="btn-leave"
              class="giga-blue_outlined_button no-icon"
              @click="closeVersionsModal()"
            >
              {{ $t("cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { documentService } from "@/views/service/document.service";

export default {
  name: "VersionsDocument",
  components: {},
  data() {
    return {};
  },
  props: {
    modalId: {
      type: String,
      required: true
    },
    selectedDocument: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters("document", ["getVersionsDocument"])
  },
  methods: {
    ...mapActions("notification", ["closeModal"]),
    ...mapActions("document", ["replaceDocumentsAction"]),
    getFileExtention(filename) {
      return filename.split(".").pop();
    },
    closeVersionsModal() {
      this.closeModal({ instance: this.$root, id: this.modalId });
    },
    downloadDoc(docId) {
      documentService.downloadDocument(docId);
    },
    currentDocument() {
      return this.getVersionsDocument.reduce((min, max) =>
        min.version > max.version ? min : max
      );
    }
  }
};
</script>

<style scoped lang="scss">
.giga-files_upload_section {
  padding: 10px 30px 10px 100px;
  border-radius: 6px;
  border: 2px solid #e0e7ee;
  width: 96%;
  background-color: #f4f6fa;
  margin-bottom: 15px;
  .giga-files_upload_header {
    display: flex;
    flex-wrap: wrap;

    .giga-files_header_col_name {
      flex: 0 0 55%;
      max-width: 65%;
    }

    .giga-files_header_col_date {
      flex: 0 0 18%;
      max-width: 45%;
    }

    .giga-files_header_col_type {
      flex: 0 0 10%;
      max-width: 45%;
    }
  }
}

.giga-upload_files_list {
  .giga-upload_file_item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-bottom: 30px;

    &:last-child {
      margin-bottom: 0;
    }

    .giga-upload_file_date {
      flex: 0 0 18%;
      max-width: 45%;
    }

    .giga-upload_file_type {
      flex: 0 0 10%;
      max-width: 45%;
    }

    .giga-upload_file_name {
      flex: 0 0 55%;
      max-width: 65%;
      font-size: 15px;
      font-weight: 600;
      color: #132d48;
      display: flex;
      align-items: center;

      .extention-icon {
        width: 40px;
        height: 40px;
        border-radius: 6px;
        background-color: #e0e7ee;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 15px;

        img {
          width: 20px;
        }
      }
    }
  }
}

.extention-icon {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background-color: #e0e7ee;
  justify-content: center;
  align-items: center;
  margin-right: 15px;

  img {
    width: 20px;
  }
}
</style>
